






















































import { Vue, Component } from "vue-property-decorator";
import { Collapse, CollapseItem, Icon, Image as VanImage, ImagePreview, NoticeBar } from "vant";

const trainAuthImages = {
  "1.1": require("@/assets/train-auth/1.1.png"),
  "1.2": require("@/assets/train-auth/1.2.png"),
  "1.3": require("@/assets/train-auth/1.3.png"),
  "2.1": require("@/assets/train-auth/2.1.png"),
  "2.2": require("@/assets/train-auth/2.2.png"),
  "3.1": require("@/assets/train-auth/3.1.png"),
  "3.2": require("@/assets/train-auth/3.2.png"),
  "3.3": require("@/assets/train-auth/3.3.png"),
  "3.4": require("@/assets/train-auth/3.4.png"),
  "3.5": require("@/assets/train-auth/3.5.png"),
  "3.6": require("@/assets/train-auth/3.6.png"),
};

@Component({
  name: "trainPaymentGuide",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [NoticeBar.name]: NoticeBar,
  },
})
export default class TrainPaymentGuide extends Vue {
  activeNames = "binding";
  processSteps = [
    {
      index: "1",
      title: "因公认证流程",
      items: [
        { index: "1.1", description: "点击<strong class='action-text'>「火车因公认证」</strong>按钮，进入支付宝企业码认证页，加入上海国际旅行社企业。", image: trainAuthImages["1.1"] },
        { index: "1.2", description: "点击<strong class='action-text'>「同意协议并认证」</strong>按钮完成认证，认证结束后返回力程商旅 APP。", image: trainAuthImages["1.2"] },
        { index: "1.3", description: "认证完成后，可在页面查看已加入的企业码信息，确认企业归属。", image: trainAuthImages["1.3"] },
      ],
    },
    {
      index: "2",
      title: "免密代扣签约",
      items: [
        { index: "2.1", description: "点击<strong class='action-text'>「免密代扣签约」</strong>按钮打开支付宝，开通企业码免密支付，使用上海国际旅行社账户完成支付，无需再通过个人支付宝付款。", image: trainAuthImages["2.1"] },
        { index: "2.2", description: "点击<strong class='action-text'>「同意并开通」</strong>免密支付后，返回力程商旅 APP 即可。", image: trainAuthImages["2.2"] },
      ],
    },
    {
      index: "3",
      title: "关联12306",
      items: [
        { index: "3.1", description: "点击<strong class='action-text'>「关联12306」</strong>按钮，进入对应的账号关联页面。", image: trainAuthImages["3.1"] },
        { index: "3.2", description: "输入12306账号和密码，点击<strong class='action-text'>「关联12306」</strong>按钮完成关联。", image: trainAuthImages["3.2"] },
        { index: "3.2.1", special: true, description: "如遇到提示需要人脸核验，点击<strong class='action-text'>「前往核验」</strong>按钮进入核验页面，输入账号密码后完成人脸核验。", image: trainAuthImages["3.3"] },
        { index: "3.2.2", branch: true, description: "输入用户名与密码，点击<strong class='action-text'>「提交人脸核验」</strong>按钮。", image: trainAuthImages["3.6"] },
        { index: "3.2.3", branch: true, description: "点击<strong class='action-text'>「开始识别」</strong>按钮进行人脸核验。", image: trainAuthImages["3.4"] },
        { index: "3.2.4", branch: true, description: "验证成功后，点击<strong class='action-text'>「下一步」</strong>返回预订首页。", image: trainAuthImages["3.5"] },
      ],
    },
  ];

  previewScreenshot(image: string) {
    ImagePreview([image]);
  }

  questions = [
    {
      name: "binding",
      title: "已经认证企业码，为什么还要开通免密代扣？",
      answer: "企业码认证用于加入企业并确认差旅身份；免密代扣用于购票时按企业规则发起支付，两者用途不同。",
    },
    {
      name: "payment",
      title: "钱从哪里扣？",
      answer: "符合企业码支付条件的订单，按本流程由上海国际旅行社企业账户结算；最终以支付宝授权页和支付确认页为准。",
    },
    {
      name: "impact",
      title: "会影响我的支付宝吗？",
      answer: "只会增加一项可关闭的服务授权，不会因认证或查看本页面自动扣款；个人账户是否参与支付，以确认页为准。",
    },
    {
      name: "safety",
      title: "开通免密支付安全吗？",
      answer: "免密授权仅用于约定的企业差旅服务，并受授权范围、限额和支付宝风控规则约束。开通前请核对服务方和期限。",
    },
    {
      name: "auto-charge",
      title: "会自动扣款或自动续费吗？",
      answer: "不会因完成认证或签约立即扣款；提交符合条件的火车票订单后，平台才会按授权发起代扣，也不会自动续费。",
    },
    {
      name: "limit",
      title: "免密支付有额度限制吗？",
      answer: "有，单次扣款及其他限制以支付宝授权页和企业签约规则为准。",
    },
    {
      name: "device",
      title: "换手机或手机号后还需要重新绑定吗？",
      answer: "同一支付宝账号换手机通常可以继续使用；更换支付宝账号后，需按页面提示重新绑定。",
    },
    {
      name: "leave",
      title: "离职后还能继续使用吗？",
      answer: "企业可回收企业码权限或额度，离职后是否可用以企业配置为准，已产生的历史订单不受影响。",
    },
    {
      name: "account",
      title: "如何查账和申请退款？",
      answer: "优先在平台订单详情查看订单、支付和退款状态；如支付宝有对应记录，再到支付宝“账单”查看，退款时间以支付渠道为准。",
    },
    {
      name: "unbind",
      title: "如何解绑？",
      answer: "先在支付宝“设置 - 支付设置 - 免密支付/自动扣款”关闭服务，再到“隐私 - 授权管理”取消相关授权；企业码成员关系由企业管理员管理。",
    },
    {
      name: "after-unbind",
      title: "解绑后额度和历史订单怎么办？",
      answer: "解绑后不能继续使用该企业码权限或额度，额度不会转入个人支付宝；历史消费记录和已产生订单不受影响。",
    },
    {
      name: "rebind",
      title: "解绑后还能重新绑定吗？",
      answer: "如需恢复使用，请联系企业管理员或客服，按当前页面提示重新授权。",
    },
    {
      name: "lost-phone",
      title: "手机丢失后怎么办？",
      answer: "请尽快在其他设备关闭免密授权，并联系支付宝客服 95188 核实异常交易。",
    },
    {
      name: "contacts",
      title: "下单联系人为什么不允许修改？",
      answer: "绑定企业码后，联系人已与企业预订系统关联，修改可能导致预订失败。如需变更联系人信息，请返回预订账号修改相关信息后，重新发起预订。",
    },
  ];
}
